import connectFactory from './connectFactory';
import createComponentFactory from './createComponentFactory';
import ProviderFactory from './ProviderFactory';
import ThemeProviderFactory from './ThemeProviderFactory';
import withThemeFactory from './withThemeFactory';
import createTheme from './createTheme';
import { THEME_CHANNEL } from './themeChannel';

export { connectFactory, createComponentFactory, ProviderFactory, ThemeProviderFactory, withThemeFactory, createTheme, THEME_CHANNEL };


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-bindings/es/index.js
// module id = 92
// module chunks = 1